export class BackupStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<BackupStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<BackupStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
